import React from "react"
import Head from "next/head"

type Props = {
  children?: HTMLElement
  data: {
    title: string
    description: string
    url: string
    coverImage: string
    type: string
  }
}

const Metadata = ({ data, children }: Props) => {
  const url =
    data?.url || (typeof window !== "undefined" ? window.location.href : "")
  const image =
    data?.coverImage ||
    "https://www.suraasa.com/assets/logos/suraasa-meta-img.jpg"

  const title = data?.title || "Suraasa"
  const description =
    data?.description ||
    "Access a wide variety of teacher training courses and learn from leading educationists around the world. Also, showcase your skills with a certification."

  return (
    <Head>
      <title>{title}</title>
      <meta content={title} name="title" />
      <meta content={description} name="description" />
      <link href={url} rel="canonical" />

      {children && children}

      {/* Open Graph / Facebook */}
      <meta content={data?.type ?? "website"} property="og:type" />
      <meta content={url} property="og:url" />
      <meta content={title} property="og:title" />
      <meta content={description} property="og:description" />
      <meta content={image} property="og:image" />

      {/* Twitter */}
      <meta content="summary_large_image" property="twitter:card" />
      <meta content={url} property="twitter:url" />
      <meta content={title} property="twitter:title" />
      <meta content={description} property="twitter:description" />
      <meta content={image} property="twitter:image" />
    </Head>
  )
}

export default Metadata
